"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    animationBackgroundColor: palette.elLight,
    color: palette.tInactive,
    borderColor: 'transparent',
    background: 'transparent',
    boxShadow: 'none',
    fontWeight: palette.twNormal,
    focusColor: palette.tInactive,
    focusBorderColor: 'transparent',
    focusBackground: 'transparent',
    focusBoxShadow: 'none',
    hoverColor: palette.tFilled,
    hoverBorderColor: 'transparent',
    hoverBackground: 'transparent',
    hoverBoxShadow: 'none',
    activeColor: palette.tActive,
    activeBorderColor: 'transparent',
    activeBackground: palette.elLightest,
    activeBoxShadow: 'none',
    disabledColor: palette.tDisabled,
    disabledBorderColor: 'transparent',
    disabledBackground: 'transparent',
    disabledBoxShadow: 'none'
  };
}